import TFormMultiSelect from './FormMultiSelect.vue'

export const FormMultiSelect = TFormMultiSelect
